// extracted by mini-css-extract-plugin
export default {"container":"pl-z","title":"ql-z","linkContainer":"rl-z","viewItemLink":"sl-z"};